import React from 'react';
import { Checkbox } from '@prisjakt/ui-inputs';
import * as S from './styles';
import { IPriceFilter } from '../types';

const PriceFilters: React.FC<IPriceFiltersProps> = props => {
  if (!Array.isArray(props.priceFilters)) return null;

  return (
    <>
      {props.priceFilters.map(
        priceFilter =>
          !priceFilter.showAsQuickFilter &&
          !priceFilter.hide && (
            <S.PriceFilter key={priceFilter.name} className={props.className}>
              <Checkbox
                name={priceFilter.name}
                checked={priceFilter.checked}
                onChange={props.onFilterChanged}
                label={priceFilter.shortLabel || priceFilter.label}
              />
            </S.PriceFilter>
          )
      )}
    </>
  );
};

interface IPriceFiltersProps {
  className?: string;
  priceFilters: IPriceFilter[];
  onFilterChanged: any;
}

export default PriceFilters;
